import React from "react"
import { validateCustomInput } from "../../../../../helpers/validators"
import { AppFunctionComponent } from "../../../../../types"
import { CustomFormField, InputType } from "./custom-form.interface"
import {
  FormInput,
  StyledCheckbox,
  StyledCustomFormTextarea,
  StyledSelect,
} from "./custom-form.styled"

type CustomFormInputResolverProps = {
  field: CustomFormField
  formState: {
    [key: string]: string | boolean
  }
  validationErrors: {
    [key: string]: string
  }
  setValidationErrors: React.Dispatch<
    React.SetStateAction<{
      [key: string]: string
    }>
  >
  setFormState: React.Dispatch<
    React.SetStateAction<{
      [key: string]: string | boolean
    }>
  >
}

const CustomFormInputResolver: AppFunctionComponent<
  CustomFormInputResolverProps
> = ({
  field,
  setValidationErrors,
  setFormState,
  validationErrors,
  formState,
}) => {
  const handleChange = (value: string | boolean) => {
    void validateCustomInput(
      field.label,
      value,
      field.required,
      setValidationErrors
    )
    void setFormState((prevFormState) => ({
      ...prevFormState,
      [field.label]: value,
    }))
  }
  if (field.type === InputType.Input) {
    return (
      <FormInput
        name={field.id}
        key={field.label}
        label={field.label}
        onValueChange={handleChange}
        value={formState[field.label]}
        error={validationErrors[field.label]}
        optional={!field.required}
        type="textarea"
        maxLength={100}
      />
    )
  } else if (field.type === InputType.Dropdown) {
    return (
      <StyledSelect
        id={field.id}
        options={field.options}
        key={field.label}
        placeholder={field.label}
        onChange={(event) => handleChange(event.target.value)}
        value={formState[field.label].toString()}
        required={field.required}
        error={validationErrors[field.label]}
      />
    )
  } else if (field.type === InputType.Checkbox) {
    return (
      <StyledCheckbox
        id={field.id}
        key={field.label}
        label={field.label}
        onChange={(event) => handleChange(event.target.checked)}
        required={field.required}
      />
    )
  } else if (field.type === InputType.Textarea) {
    return (
      <StyledCustomFormTextarea
        name={field.id}
        key={field.label}
        placeholder={field.label}
        onChange={(event) => handleChange(event.target.value)}
        value={formState[field.label] as string}
        error={validationErrors[field.label]}
        required={field.required}
        maxLength={700}
      />
    )
  } else {
    return null
  }
}

export default CustomFormInputResolver
